"use client";

import { useTranslations } from "next-intl";
import { getImagePath } from "@/lib/utils";

export default function useBenefits() {
  const t = useTranslations("benefits");

  const benefits = [
    {
      id: 1,
      title: t("partners.title"),
      sub: t("partners.sub"),
      hoverTitle: t("partners.hoverTitle"),
      description: t("partners.description"),
      image: {
        src: getImagePath("/images/benefits/partner.webp"),
        width: "35%",
        height: "auto",
        alt: t("partners.alt"),
      },
      bgGradient: "from-[#A23465] to-[#EA7F75]",
      textColor: "text-white",
      action: "/own-and-earn",
    },
    {
      id: 2,
      title: t("producers.title"),
      sub: t("producers.sub"),
      hoverTitle: t("producers.hoverTitle"),
      description: t("producers.description"),
      image: {
        src: getImagePath("/images/benefits/producer.webp"),
        width: "40%",
        height: "auto",
        alt: t("producers.alt"),
      },
      bgGradient: "from-[#003399] to-[#0098CC] to-[#0099CC]",
      textColor: "text-white",
      action: "/benefits-for-producers",
    },
    {
      id: 3,
      title: t("customers.title"),
      sub: t("customers.sub"),
      hoverTitle: t("customers.hoverTitle"),
      description: t("customers.description"),
      image: {
        src: getImagePath("/images/benefits/user.webp"),
        width: "52%",
        height: "auto",
        alt: t("customers.alt"),
      },
      bgGradient: "from-[#F26322] to-[#F78F2E]",
      textColor: "text-white",
      action: "/benefits-for-customers",
    },
  ];

  return benefits;
}
